export function removeSpaces(text: string): string {
    return text.replace(/\s/g, '');
}
